import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { TextInput } from '../lib/wrappers/Inputs';

export const StatusLabels = {
    pageTitle: 'Statuses',
    singleLabel: 'Status',
    Title: 'Tagline',
    description: 'Status',
};

export const StatusList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={StatusLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label={StatusLabels.Title} source="Title" />
                    <TextField
                        label={StatusLabels.description}
                        source="description"
                    />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const StatusEdit = (props) => (
    <Edit {...props} title={<ShowTitleByDescription />} redirect="edit">
        <StatusInputs {...props} />
    </Edit>
);

export const StatusCreate = (props) => (
    <Create {...props} redirect="edit">
        <StatusInputs {...props} />
    </Create>
);

export const StatusShow = (props) => {
    return (
        <Show {...props} title={<ShowTitleByDescription />}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField label={StatusLabels.Title} source="Title" />
                <TextField
                    label={StatusLabels.description}
                    source="description"
                />
                <TextField source="created_at" />
                <DateField source="updated_at" />
            </SimpleShowLayout>
        </Show>
    );
};

const StatusInputs = (source) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SimpleForm {...source}  toolbar={<EditToolbar />}>
                <TextInput source="id" disabled />
                <TextInput label={StatusLabels.Title} source="Title" />
                <TextInput
                    label={StatusLabels.description}
                    source="description"
                />
                <TextInput source="created_at" disabled />
                <TextInput source="updated_at" disabled />
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};
